import { Modal } from "antd";
import { messages } from "../../constants/messages";

/**
 *
 * @param {func} deleteAction
 * @param {string} item
 * @returns
 */
function ModalDeleteConfirmTreePhongBan(
  deleteAction: (arg0: any) => void,
  item: any,
  getList: () => void,
  setLoadingButtonDelete: (arg0: boolean) => void
) {
  Modal.confirm({
    title: messages.MODAL_DELETE_TITLE,
    content: messages.MODAL_DELETE_CONTENT,
    onOk(e) {
      e();
      deleteAction(item);
      setLoadingButtonDelete(false);
      setTimeout(() => {
        getList();
      }, 0);
    },
    okText: messages.MODAL_CONFIRM_OK,
    onCancel() {
      setLoadingButtonDelete(false);
    },
    cancelText: messages.MODAL_CONFIRM_CANCEL,
  });
}

export default ModalDeleteConfirmTreePhongBan;
